import React, { ReactNode } from 'react';

function PageTitle(props: { children: ReactNode | ReactNode[] }) {
  return <div className="App-pageTitle">{props.children}</div>;
}

export default PageTitle;
